import { FC } from 'react';
import { Box, Checkbox, FormControlLabel, MenuItem, Typography } from '@mui/material';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { CoreTextField } from '../../../_core/components/_ui/core-textfield';
import { CoreSelect } from '../../../_core/components/_ui/core-select';
import { SurveyQuestionTypeArray, SurveyQuestionTypeEnum } from '@families-link/shared';
import { useTranslation } from 'react-i18next';
import { TranslateQuestionOptions } from './trnaslate-question-options-array.component';

export const SurveyTranslateQuestionsArray: FC = () => {
	const [t] = useTranslation();
	const {
		control,
		formState: { errors },
		watch,
		getValues,
	} = useFormContext();
	const { fields, append, remove, move } = useFieldArray({
		control,
		name: `questions`,
	});

	return (
		<>
			<Box sx={{ paddingTop: '16px', overflowY: 'auto', px: '20px' }}>
				{fields.map((field, index) => (
					<Box
						key={field.id}
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							marginBottom: '16px',
							paddingBottom: '16px',
							borderBottom: '1px solid lightgrey',
						}}
					>
						<Box sx={{ width: '100%' }}>
							<Box sx={{ display: 'flex', alignItems: 'center' }}>
								<Controller
									name={`questions.${index}.translatedText`}
									control={control}
									render={({ field }) => (
										<CoreTextField
											{...field}
											label={t('survey-templates.forms.labels.question')}
											requiredMark
											fullWidth
											labelHint={getValues(`questions.${index}.text`)}
											placeholder={getValues(`questions.${index}.text`)}
											controlSx={{ marginRight: '16px' }}
										/>
									)}
								/>

								<CoreSelect
									{...field}
									label={t('survey-templates.forms.labels.question-type')}
									fullWidth
									disabled
									value={watch(`questions.${index}.type`) || ''}
									controlSx={{ marginRight: '16px' }}
								>
									{SurveyQuestionTypeArray.map((value) => (
										<MenuItem key={value} value={value}>
											{value}
										</MenuItem>
									))}
								</CoreSelect>
								<FormControlLabel
									control={<Checkbox disabled {...field} checked={watch(`questions.${index}.isRequired`) || false} />}
									label={'Required'}
									sx={{ fontSize: '14px', pt: '28px', m: 0 }}
								/>
							</Box>
							<Box sx={{ marginTop: '16px' }}>
								{watch(`questions.${index}.type`) === SurveyQuestionTypeEnum.ShortText && (
									<CoreTextField
										label={t('survey-templates.forms.labels.answer-field')}
										fullWidth
										placeholder={t('survey-templates.forms.placeholders.enter-description')}
										disabled
									/>
								)}
								{watch(`questions.${index}.type`) === SurveyQuestionTypeEnum.LongText && (
									<CoreTextField
										label={t('survey-templates.forms.labels.answer-field')}
										fullWidth
										multiline
										placeholder={t('survey-templates.forms.placeholders.enter-description')}
										disabled
									/>
								)}
								{(watch(`questions.${index}.type`) === SurveyQuestionTypeEnum.Options ||
									watch(`questions.${index}.type`) === SurveyQuestionTypeEnum.MultiSelect) && (
									<>
										<Typography
											sx={{
												fontSize: 14,
												fontWeight: 300,
												lineHeight: 1.2,
												color: (theme) =>
													errors['questions'] && (errors['questions'] as any)[index]?.options
														? theme.colors.red
														: theme.colors.gray,
											}}
										>
											{t('survey-templates.forms.labels.options')}
										</Typography>
										<TranslateQuestionOptions questionIndex={index} />
									</>
								)}
							</Box>
						</Box>
					</Box>
				))}
			</Box>
		</>
	);
};
